// @flow
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const NewSection = styled.div`
  padding: 0;

  ${minMediaQueries.tablet`
    padding: 18px 24px;
  `};

  ${minMediaQueries.miniDesktop`
    padding: 18px 30px;
  `};
`;

export const NewSectionInner = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth};
  padding: 30px;
  margin: 0 auto;
  ${({ theme, grey }) =>
    (grey
      ? `
      border-radius: ${theme.borderRadius};
      background-color: ${theme.colors.uiLL};
    `
      : null)};
  ${({ textAlign }) => textAlign && `text-align: ${textAlign};`};

  ${maxMediaQueries.miniDesktop`
    padding-left: 24px;
    padding-right: 24px;
  `};

  ${maxMediaQueries.phone`
    padding-left: 15px;
    padding-right: 15px;
  `};

  ${({ withInsideNavigation = false }) => (withInsideNavigation ? 'padding-top: 60px;' : '')}
`;
